import { AT } from '../actions/actionTypes';
import useDispatcher from './useDispatcher';
import * as MyKeysApiConfiguration from '../core/apis/mykeys/configuration';
import { MyKeysPromiseMap } from '../core/apis/mykeys/mappings';
import { DelayBetweenTries } from '../modules/setup';
import { Language } from '../core/localization/model';
import { getLanguage } from '../core/localization/utils';
import { useSelector } from 'react-redux';
import { ReduxState } from '../interfaces';
import {State as SetupState} from '../modules/setup';
import Logger from '../libs/logger'; import { LogArea } from '../libs/logger/const';


export interface useStoreCtxResult extends SetupState {
  updateCtx: ()=> void;
  setStoreUser: (userId: string)=> void;
  setLanguage: (code: string)=> void;
}

const useApp = (): useStoreCtxResult => {
  const { doEmptyAction, doAction } = useDispatcher();
  const setupState = useSelector((s: ReduxState) => s.setupState);

  const updateCtx = () => {
    Logger.info(['updateCtx'], LogArea.Redux);
  
    MyKeysApiConfiguration.updateCtx()
      .then(MyKeysPromiseMap)
      .then((data: boolean) => {
        doEmptyAction(AT.CONFIG_UPDATE_CTX_SUCCESS);
        if (data) {
          doEmptyAction(AT.DEVICES.RESET);
          doEmptyAction(AT.ORDERS.RESET);
          doEmptyAction(AT.DTYPES.RESET);
          doEmptyAction(AT.CUSTOMERS.RESET);
        }
      })
      .catch((/* err: ErrorDataResponse */) => {
        setTimeout(
          () => doEmptyAction(AT.CONFIG_UPDATE_CTX_ERROR),
          DelayBetweenTries
        );
      });
  
    doEmptyAction(AT.CONFIG_UPDATE_CTX_FETCH);
  };

  const setLanguage = (code: string) => {
    const language = getLanguage(code);
    doAction<Language>(AT.I18N_SET_LANGUAGE, language);
  };

  const setStoreUser = (userId: string) => {
    doEmptyAction(AT.CONFIG_USER_INFO_RECEIVED);
  };

  return {...setupState, updateCtx, setLanguage, setStoreUser };
};

export default useApp;
